// E-Invoice DocNet notification routing (BOL-430/431).
// Mirrors the GET / PUT / DELETE contract on
// doc2-api/routers/electronic_document/router.py.

import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';

export interface AgentRegistryEntry {
  agent_key: string;
  label: string;
  description: string;
  celery_task: string;
  default_code_prefixes: string[];
}

export interface NotificationRoute {
  id: string;
  code_prefix: string;
  agent_key: string;
  enabled: boolean;
}

export interface AgentsResponse {
  success: boolean;
  agents: AgentRegistryEntry[];
}

export interface RoutesResponse {
  success: boolean;
  routes: NotificationRoute[];
}

export default class NotificationRoutingApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  /** Fetch the read-only DocNet agent registry. */
  public async listAgents(): Promise<AgentsResponse> {
    return super.get(api.einvoice_notification_agents);
  }

  /** List the org's configured (code_prefix → agent_key) routes. */
  public async listRoutes(): Promise<RoutesResponse> {
    return super.get(api.einvoice_notification_routes);
  }

  /** Upsert one route. Pass `enabled=false` to park a route without
   *  losing its config; the resolver only considers `enabled=true`. */
  public async upsertRoute(
    codePrefix: string,
    agentKey: string,
    enabled: boolean,
  ): Promise<{ success: boolean; route: NotificationRoute }> {
    const formData = new FormData();
    formData.append('code_prefix', codePrefix);
    formData.append('agent_key', agentKey);
    formData.append('enabled', enabled ? 'true' : 'false');
    return super.put(api.einvoice_notification_routes, formData);
  }

  /** Soft-delete a route by code_prefix. */
  public async deleteRoute(
    codePrefix: string,
  ): Promise<{ success: boolean; removed: boolean }> {
    return super.delete(
      `${api.einvoice_notification_routes}/${encodeURIComponent(codePrefix)}`,
      undefined,
    );
  }
}
